import { Box, Dialog } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import React, { useState } from 'react';
import { Contact } from '../../modules/contacts/models/contacts.types';
import { IconButton } from '../../shared/ui/IconButton/IconButton';
import ContactDetail from './ContactDetail';

const ColumnActions = React.memo(({ row }: { row: Contact }) => {
  const [contactDetailOpen, setContactDetailOpen] = useState(false);
  return (
    <Box
      className="flex w-full h-full justify-center"
      sx={{ backgroundColor: '#C0E2FA' }}
      onClick={(e) => e.stopPropagation()}
    >
      <IconButton
        icon={['fal', 'eye']}
        sxIcon={{ color: 'primary.main' }}
        onClick={() => setContactDetailOpen(true)}
      />

      <IconButton
        icon={['fal', 'pen']}
        sxIcon={{ color: 'primary.main' }}
        // onClick={() =>onRowEdit(props.rowId)} TODO FIX
      />

      <IconButton
        icon={['fal', 'trash']}
        sxIcon={{ color: 'primary.main' }}
        onClick={() => {}}
      />
      {contactDetailOpen && (
        <Dialog open={contactDetailOpen}>
          <ContactDetail
            contact={row}
            onClose={() => setContactDetailOpen(false)}
          />
        </Dialog>
      )}
    </Box>
  );
});

export default ColumnActions;
